<!-- eslint-disable import/no-cycle -->
<div class="mt-2">
  <h3 class="font-lato text-xs font-bold uppercase">Which location?</h3>
  <mat-form-field>
    <mat-label>Please select a location</mat-label>
    <input
      type="text"
      placeholder="Please select a location"
      aria-label="Number"
      matInput
      [matAutocomplete]="auto"
      [formControl]="autocompleteLocationControl"
      #input
    />
    <mat-autocomplete
      (optionSelected)="onLocationSelected($event)"
      #auto="matAutocomplete"
      (valueChange)="onLocationSelected($event)"
    >
      @for (l of filteredOptions | async; track l.Z_Location__r.Name) {
        <mat-option [value]="l.Z_Location__r.Name" [disabled]="l.disabled">
          {{ l.Z_Location__r.Name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
